import Button from "Components/button";
import { TextWidget } from "Components/optionForm";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import React, { memo, useCallback } from "react";
import locale from "./connectionsBlock.locale";
const SIZES = {
    TESTING_HEIGHT: 36
};
const panelBodyStyle = {
    display: "grid",
    gap: themeVariables["padding-xs"],
    gridTemplateColumns: "1fr 1fr",
    padding: `${themeVariables["padding-xs"]} ${themeVariables["padding-xs"]}`
};
function ConnectionBlock(props) {
    var _a, _b, _c, _d;
    const handleChangeDraft = useCallback((value, fieldName) => {
        if (!fieldName)
            return;
        props.onConnectionChanged && props.onConnectionChanged(props.type, fieldName, value);
    }, [props.onConnectionChanged, props.type]);
    const handleTest = useCallback(() => props.connection && props.onTest && props.onTest(props.connection), [props.onTest, props.connection]);
    return (React.createElement("div", null,
        React.createElement("h5", { className: "font-bold pl-0_75 pr-0_75 pt-0_25 pb-0_25" }, props.title),
        React.createElement("div", { style: panelBodyStyle },
            React.createElement(TextWidget, { value: ((_a = props.connection) === null || _a === void 0 ? void 0 : _a.Url) || "", fieldName: "Url", label: locale.URL, labelMode: "floating", onChange: handleChangeDraft, readOnly: !props.onConnectionChanged, height: 44 }),
            React.createElement(TextWidget, { value: ((_b = props.connection) === null || _b === void 0 ? void 0 : _b.ApiKey) || "", fieldName: "ApiKey", labelMode: "floating", label: locale.API_KEY, onChange: handleChangeDraft, readOnly: !props.onConnectionChanged, height: 44 })),
        React.createElement("div", { className: "field-box" }),
        React.createElement("div", { className: "field-box d-flex justify-content-flex-end" },
            React.createElement(Button, { className: classNames("font-small line-height-base text-gray-500", ((_c = props.connection) === null || _c === void 0 ? void 0 : _c.Tested) === true
                    ? "bg-primary-100 text-primary-500"
                    : ((_d = props.connection) === null || _d === void 0 ? void 0 : _d.Tested) === false && "bg-danger-100 text-danger-500"), height: SIZES.TESTING_HEIGHT, onClick: handleTest }, locale.TESTING))));
}
export default memo(ConnectionBlock);
